module.exports = __webpack_public_path__ + "media/images/nocampaign-desktop-2b969e4379f983bf453149a5175c27dd.jpg";